exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.slider-widget img[data-v-598a50c8]{\n\t\t -o-object-fit: cover;\n\t\t    object-fit: cover;\n  \t\theight: 100%;\n}\n.slider-widget .card .position-relative[data-v-598a50c8]{\n\t\theight: 100%;\n}\n", ""]);

// exports
